import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function VideosSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-2">
              精选视频
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              独家爆料视频，第一手现场 footage，还原事件真相
            </p>
          </div>
          <Link
            to="/category/internet"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部视频
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {videos.map((video) => (
            <article key={video.id} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300">
              <Link to={`/article/${video.slug}`} className="block">
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="640"
                    height="360"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-xl md:text-2xl" />
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
                    {video.duration}
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{video.category}</span>
                    <div className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line" />
                      </span>
                      <span>{video.views.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}